import React, { FC, PropsWithChildren } from 'react';
import { OptionLabelProps } from './types';
import { FormHelperText } from '@chakra-ui/react';
import { Typography } from '../Typography';
import { IconButton } from '../IconButton';

type OptionLabelPropsWithChildren = PropsWithChildren<OptionLabelProps>;

export const OptionLabel: FC<OptionLabelPropsWithChildren> = ({ label, helpText, tooltip, children }) => {
  return (
    <>
      <Typography as="span" textAlign="center">
        {label}
        {tooltip && (
          <IconButton
            icon={{ iconName: 'info-circle', prefix: 'far' }}
            isRound={true}
            minH={'auto'}
            minW={'auto'}
            w={'auto'}
            h={'auto'}
            ml={'xs'}
            tooltip={{
              content: tooltip.content,
              placement: 'top',
            }}
            verticalAlign={'baseline'}
            variant="ghost"
            colorScheme="info"
          />
        )}
      </Typography>
      {helpText && <FormHelperText fontSize="sm">{helpText}</FormHelperText>}
      {children}
    </>
  );
};

OptionLabel.displayName = 'OptionLabel';
